// Port of api/fuel/app/classes/controller/api/monty/hindex/update.php
import DB from 'offline/db'
import User from 'offline/model/user'
import HindexType from 'offline/model/hindex/type'
import { currentUser, ensureUniqueSlug, invalid, payload, persist } from './shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return invalid()

	var route = params.__offlineRoute || {}
	var type = HindexType.with_id(parseInt(route.id, 10) || 0)

	if (!type) return invalid()
	if (type.get_user_id() !== user.get_id() || type.get_public()) return invalid()

	var isPublic = parseInt(params.public || 0, 10) ? 1 : 0
	DB.run('UPDATE hindex_type SET hindex_public = ?, hindex_name = ?, hindex_slug = ?, hindex_description = ?, hindex_filter = ? WHERE hindex_id = ?', [
		isPublic,
		params.name || '',
		ensureUniqueSlug(params.name, isPublic, user.get_id(), type.get_id()),
		params.description || '',
		JSON.stringify(params.filter || {}),
		type.get_id()
	])

	if (JSON.stringify(type.get_filter() || {}) !== JSON.stringify(params.filter || {})) {
		DB.run('UPDATE hindex_track SET track_generated = 0 WHERE hindex_id = ?', [type.get_id()])
	}

	var freshType = HindexType.with_id(type.get_id())
	var freshUser = User.with_id(user.get_id())
	return persist(payload(freshUser, freshType))
}
